export class RNBridge {

    private constructor() {
    }

    public static send = (msg: string): void => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(msg);
        }
    }
}
